import React, { useState, useEffect, useContext } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { getItemStorage } from "../../../Localstorage/useLocalStorage";
import { UserData } from "../../../contexts/UserInfoContext";
import { IoHomeOutline } from "react-icons/io5";
import { IoSchoolOutline } from "react-icons/io5";
import { IoReaderOutline } from "react-icons/io5";
import { IoPersonOutline } from "react-icons/io5";

const MobileNavbar = () => {
  const token = getItemStorage("token");
  const { user } = useContext(UserData);

  const Menus = [
    {
      name: "خانه",
      link: "/",
      icon: <IoHomeOutline className="size-5" />,
      align: "-translate-x-0",
    },
    {
      name: "آموزشگاه",
      link: "/courses",
      icon: <IoSchoolOutline className="size-5" />,
      align: "-translate-x-[84px]",
    },
    {
      name: "وبلاگ",
      link: "/magazine",
      icon: <IoReaderOutline className="size-5" />,
      align: "-translate-x-[169px]",
    },
    {
      name: "پروفایل",
      link: token && user?.user?.id ? "/user" : "/auth",
      icon: <IoPersonOutline className="size-5" />,
      align: "-translate-x-[252px]",
    },
  ];

  const navigate = useNavigate();

  const [active, setActive] = useState(null);

  const loc = useLocation();

  useEffect(() => {
    switch (loc.pathname) {
      case "/":
        setActive(0);
        break;

      case "/shop":
        setActive(1);
        break;

      case "/blog":
        setActive(2);
        break;

      case "/user":
      case "/auth":
      case "/admin":
        setActive(3);
        break;

      default:
        setActive(0);
        break;
    }
  }, [loc]);

  // const navMenu = (menu, i) => {
  //   setActive(i)

  //   navigate(menu.link)
  // }

  return (
    <div className="mobile-nav bg-[#222] w-full flex justify-center px-8 shadow-[0px_5px_25px_rgba(104,132,168,0.2)] rounded-t-xl fixed bottom-0 lg:hidden z-[999]">
      <ul className="flex relative gap-5">
        {/* <span
          className={`bg-gradient-to-tl from-blue-600 to-blue-300  transition-all duration-300 ${
            active && Menus[active].align
          } border-4 border-[#f3f5f6] h-16 w-16 absolute
             -top-5 rounded-full`}
        >
          <span
            className="w-3.5 h-3.5 bg-transparent absolute top-4 -left-[18px] 
              rounded-tr-[11px]"
          ></span>
          <span
            className="w-3.5 h-3.5 bg-transparent absolute top-4 -right-[18px] 
              rounded-tl-[11px]"
          ></span>
        </span> */}
        {Menus.map((menu, i) => (
          <li key={i} className="min-w-[64px] w-fit">
            <NavLink
              to={menu.link}
              className="menu-nav-mob text-gray-200 flex flex-col items-center gap-2 text-center p-3"
              // onClick={() => navMenu(menu, i)}
            >
              {menu.icon}

              <span className={`-mt-1 text-sm transition-all duration-300`}>
                {menu.name}
              </span>
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MobileNavbar;
